import { nanoid } from 'nanoid';

// SQL DATA
const sqlData = [
  // {
  //   id: nanoid(),
  //   img: '',
  //   title: '',
  //   info: '',
  //   info2: '',
  //   url: '',
  //   repo: '',
  // },

  {
    id: nanoid(),
    img: 'sql_basic-db.png',
    title: 'Basic SQL DB',
    info: 'Using a very short database I solve very basic SQL queries.',
    info2: '',
    url: '',
    repo: 'https://github.com/Shcoobz/basic-sql',
  },

  {
    id: nanoid(),
    img: 'sql_basic-queries.png',
    title: 'Northwind DB: Simple SQL Queries',
    info: 'This project involves solving a series of SQL queries to extract specific information from the Northwind database.',
    info2: '',
    url: '',
    repo: 'https://github.com/CodecoolGlobal/northwind-traders-select-sql-Shcoobz',
  },

  {
    id: nanoid(),
    img: 'sql_advanced-queries.png',
    title: 'Northwind DB: Advanced SQL Queries',
    info: 'Using the same database as before I write advanced SQL queries.',
    info2: '',
    url: '',
    repo: 'https://github.com/CodecoolGlobal/northwind-traders-join-sql-Shcoobz',
  },
];

export default sqlData;
